import { createReducer } from '@reduxjs/toolkit';

import { REQUEST_LOGS_INITIAL_STATE, REQUEST_LOGS_STORE_NAME } from './request-logs.state';
import * as Actions from './request-logs.action';

/**
 * Request log Reducers
 */
export const requestLogsReducer = createReducer(REQUEST_LOGS_INITIAL_STATE, (builder) => {
  builder
    .addCase(Actions.RESET_STORAGE_REQUEST_LOGS, () => REQUEST_LOGS_INITIAL_STATE)
    .addCase(Actions.RESET_REQUEST_LOGS_ERROR, (state) => ({ ...state, error: null }))
    .addCase(Actions.RESET_REQUEST_LOGS_RESPONSE, (state) => ({ ...state, response: null }))
    .addCase(Actions.FETCH_REQUEST_LOGS_API, (state) => ({
      ...state,
      requestLogs: {
        meta: {},
        data: [],
      },
      response: null,
      error: null,
      loading: true,
    }))
    .addCase(Actions.FETCH_REQUEST_LOGS_SUCCESS_API, (state, action: any) => ({
      ...state,
      requestLogs: action.payload,
      loading: false,
    }))
    .addCase(Actions.FETCH_REQUEST_LOGS_FAILURE_API, (state, action: any) => ({
      ...state,
      error: action.payload,
      loading: false,
    }));
});

export const requestLogsReducerConfig = {
  [REQUEST_LOGS_STORE_NAME]: requestLogsReducer,
};
